import React from 'react';
import { Header } from '@growth/dweb-header';

const ClientHeaderGI = (data) => {
  return (
    <>
      <Header
        lobName="flights"
        onLoginSuccess={() => {
          window?.location?.reload?.();
        }}
        onLogoutSuccess={() => {
          window?.location?.reload?.();
        }}
        allowInternationalLogin
        hideHeader={false}
      />
    </>
  );
};

export default ClientHeaderGI;